import React, { useState, useEffect } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import ImageContainer from "../image-container/ImageContainer";
import "../faqs/Faqs.css";
import Parser from "html-react-parser";
import LoginHeader from "../login/LoginHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import useLoading from "../../hooks/UseLoading";
import useAlert from "../../hooks/UseAlert";
import { Helmet } from "react-helmet";

export default function GolfRules() {
  const [loggedStatus, setLoggedStatus] = useState("");
  const [contentText, setContentText] = useState("");
  var url = process.env.REACT_APP_API_URL;
  const [loader, showLoader, hideLoader] = useLoading();
  const navigate = useNavigate();
  const [alert, alert_notify] = useAlert();

  useEffect(() => {
    var logged_status = localStorage.getItem("user_status");
    if (logged_status === "unlogged") {
      setLoggedStatus("unlogged");
    } else {
      setLoggedStatus("logged");
    }

    var static_content_url = "" + url + "/static_content/get_all_static_content";
    const body = { page_meta_key: "our_mission" };
    showLoader();
    axios
      .post(static_content_url, body)
      .then((response) => {
        if (response.status === 200) {
          var data = response.data.Data;
          setContentText(data.content.page_content);
        }
        hideLoader();
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/login");
        } else {
          alert_notify("error", err.response.data.Error);
        }
        hideLoader();
      });
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Top Predictor | Golf Rules</title>
        <meta
          name="description"
          content="Read the Golf Rules on Top Predictor."
        />
      </Helmet>
      {loggedStatus === "logged" ? <Header /> : <LoginHeader />}
      <ImageContainer />
      <div className="faqs_container">
        <div className="page_content_center">
          <h2 className="faqs_header">GOLF RULES</h2>
          {Parser(contentText)}
        </div>
      </div>
      <Footer />
      {loader}
      {alert}
    </React.Fragment>
  );
}
